import { useToast } from "@/components/ui/use-toast"
import { AIAnalysis } from "@/types/ai"
import ReactMarkdown from "react-markdown"
import { Button } from "@/components/ui/button"
import { RefreshCw } from "lucide-react"
import { AIGeneralTips } from "./AIGeneralTips"
import { AIFollowUpQuestions } from "./AIFollowUpQuestions"

interface AIContentProps {
  advice: AIAnalysis
  onRefresh: () => void
  compact?: boolean
}

export function AIContent({ advice, onRefresh, compact = false }: AIContentProps) {
  return (
    <div className={`rounded-md p-6 bg-gradient-to-br from-[#000808] to-[#0F1726] shadow-md ${!compact ? 'mt-2' : ''}`}>
      <div className="space-y-4">
        <div className="text-sm space-y-2">
          <div className="prose prose-sm max-w-none text-[#FFC745]">
            <ReactMarkdown>
              {advice.message}
            </ReactMarkdown>
          </div>
        </div>
        
        <AIGeneralTips tips={advice.general_tips} />
        
        <AIFollowUpQuestions followUp={advice.follow_up_questions.questions} />
        
        <div className="text-xs text-center text-[#FFC745]/80 border-t border-[#FFC745]/20 pt-2 mt-4">
          {advice.closing_message}
        </div>
        
        <div className="flex justify-center mt-4">
          <Button 
            size="sm" 
            variant="outline"
            onClick={onRefresh}
            className="flex items-center gap-1 text-[#000808] bg-[#FFC745] border-[#FFC745] hover:bg-[#FFC745]/90 hover:text-[#000808] transition-colors"
          >
            <RefreshCw className="h-3 w-3" />
            Refresh
          </Button>
        </div>
      </div>
    </div>
  )
}
